import React, { useEffect, useState } from "react";
import { Grid, Card } from "@material-ui/core";
import Components from "./e_components";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "react-responsive";
import E_Usage_header from "./e_usage_header";
import { useSelector } from "react-redux";
import CALPOWERVALUES from "./e_cal_power_values/view/e_cal_power_values";

const useStyle = makeStyles((theme) => ({
  card2Height: {
    height:"100%",
    minHeight: "23rem"
  },  
  card3Height: {
    height:'100%'
  },
  card4Height: {
    marginTop:"0.3125rem",
    minHeight: "11rem",
    height:'49%',
    marginBottom:'0.2rem'
  },
  mainContainer: {
    marginTop: "5px"
  },
  widgetGrids: {
    flexFlow: "column"
  }
}));
let widgets = [
  {
    widgetName: "E_EnergyConsumption",
    widgetRank: 3,
    wWidget: 6,
    widgetValue:true
  },
  {
    widgetName: "E_HighestUsageDays",
    widgetRank: 4,
    wWidget: 6,
    widgetValue:true
  },
  {
    widgetName: "E_MeterReads",
    widgetRank: 1,
    wWidget: 6,
    widgetValue:true
  },
  {
    widgetName: "E_UsageComparison",
    widgetRank: 2,
    wWidget: 6,
    widgetValue:true
  }
];

export default function Usage() {
  let classes = useStyle();
  const [orderWidgets, setOrderWidgets] = useState();
  const isTabletOrMobile = useMediaQuery({ minWidth: 1280 });
  useEffect(() => {
    widgets.sort((a, b) => {
      return a.widgetRank - b.widgetRank;
    });
    let inOrder = widgets.filter((i)=>i.widgetValue===true);
    setOrderWidgets(inOrder);
  }, [widgets]);
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  return (
    <>
      {orderWidgets ? (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <E_Usage_header />
          </Grid>
           <Grid item xs={12} sm={6} lg={orderWidgets[0]?.wWidget}>
                <Card className={ classes.card3Height }
                 style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
                >
                  {Components(orderWidgets?.[0])}
                </Card>
                {/* <Card className={ classes.card4Height }
                 style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
                >
                  <CALPOWERVALUES/>
                </Card> */}
              </Grid>
              <Grid item xs={12} sm={6}>
              <Card className={ classes.card2Height }
                 style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
                >
                  {Components(orderWidgets?.[2])}
                </Card>
              </Grid>
              <Grid item xs={12} sm={6}>
              <Card className={ classes.card2Height }
                 style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
                >
                  {Components(orderWidgets?.[1])}
                </Card>
              </Grid>
              <Grid item xs={12} sm={6}>
              <Card className={ classes.card2Height }
                 style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
                >
                  {Components(orderWidgets?.[3])}
                </Card>
              </Grid>
        </Grid>
      ) : (
        <Skeleton />
      )}
    </>
  );
}
